"use client";
import * as React from "react";
const SvgWarningRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 15", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M1.68 14.14h12.64c1.3 0 2.1-1.4 1.45-2.52L9.45.7a1.68 1.68 0 0 0-2.9 0L.23 11.62a1.68 1.68 0 0 0 1.45 2.51M8 8.26a.84.84 0 0 1-.84-.84V5.74c0-.46.38-.84.84-.84s.84.38.84.84v1.68c0 .46-.38.84-.84.84m.84 3.36H7.16V9.94h1.68z" }));
export {
  SvgWarningRound as default
};
